// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chameleon .ScoringLearnosityItem {
    --tw-bg-opacity: 1;
    background-color: rgb(1 92 176 / var(--tw-bg-opacity))
}`, "",{"version":3,"sources":["webpack://./chameleon/legacy/src/components/scoring/ScoringLearnosityItem.scss"],"names":[],"mappings":"AACE;IAAA,kBAAA;IAAA;AAAA","sourcesContent":[".ScoringLearnosityItem {\n  @apply bg-blue-700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
